export default "__VITE_ASSET__CgcuSjdO__"